import { Tag } from 'antd';
import React from 'react';

import { useAppVersion } from '../../../foundation/config/appVersion';

/**
 * Displays a small version badge (bottom-right, fixed) in every environment.
 * Styling is intentionally subtle: transparent background, outlined in the
 * app's primary blue so it doesn't distract from the UI.
 */
const Footer: React.FC = () => {
  const version = useAppVersion();

  return (
    <div className="layout-footer">
      <Tag className="layout-footer__version-tag">{version}</Tag>
    </div>
  );
};

export default Footer;
